"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _CSVInput_1 = require("./_CSVInput");
var _JSONInput_1 = require("./_JSONInput");
var _ParquetInput_1 = require("./_ParquetInput");
exports._InputSerialization = {
    type: "structure",
    required: [],
    members: {
        CSV: {
            shape: _CSVInput_1._CSVInput
        },
        CompressionType: {
            shape: {
                type: "string"
            }
        },
        JSON: {
            shape: _JSONInput_1._JSONInput
        },
        Parquet: {
            shape: _ParquetInput_1._ParquetInput
        }
    }
};
//# sourceMappingURL=_InputSerialization.js.map